import AutoFillDeliveryMethodsStep from '../AutoFillDeliveryMethodsStep';
import PaymentMethodsStep from '../PaymentMethodsStep';
import AutoFillShippingInfoStep from '../AutoFillShippingInfoStep';

import {
  SHIPPING_INFO_STEP,
  DELIVERY_METHODS_STEP,
  PAYMENT_STEP,
} from './constants';

const stepConfig = [
  {
    index: 1,
    title: 'shippingStep',
    key: SHIPPING_INFO_STEP,
    component: AutoFillShippingInfoStep,
  },
  {
    index: 2,
    title: 'deliveryMethodsStep',
    key: DELIVERY_METHODS_STEP,
    component: AutoFillDeliveryMethodsStep,
  },
  {
    index: 3,
    title: 'paymentStep',
    key: PAYMENT_STEP,
    component: PaymentMethodsStep,
  },
];

export default stepConfig;
